// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { v4 as uuidv4 } from 'uuid';
import { useCookies } from 'vue3-cookies';
const { cookies } = useCookies();

const firebaseConfig = {
  apiKey: import.meta.env.VUE_APP_GOOGLE_OAUTH_APIKEY,
  authDomain: import.meta.env.VUE_APP_GOOGLE_OAUTH_AUTHDOMAIN,
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

function getDid() {
  return uuidv4();
}

function setDid() {
  if (!cookies.get('did')) {
    const did = uuidv4();
    cookies.set('did', did);
  }
}

setDid();

const auth = getAuth();

export { app, auth, getDid };
